import { ACTIVITY_FILTER_CATEGORIES } from "../constants/filterCategories";
import { createFilterHelpers } from "./filterUtils";

export const {
  emptyFilters: emptyActivityFilters,
  cycleFilterValue: cycleActivityFilterValue,
  itemMatchesFilters: activityMatchesFilters,
} = createFilterHelpers(ACTIVITY_FILTER_CATEGORIES);

export const activityMatchesDateRange = (entry, dateRange) => {
  const t = new Date(entry.occurredAt);
  if (dateRange.from) {
    const from = new Date(dateRange.from + "T00:00:00");
    if (t < from) return false;
  }
  if (dateRange.to) {
    const to = new Date(dateRange.to + "T00:00:00");
    to.setHours(23, 59, 59, 999);
    if (t > to) return false;
  }
  return true;
};
